// src/store/store.ts
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { uiReducer } from '@/features/ui/uiSlice';
import { videosReducer } from '@/features/videos/videosSlice';
import { membersReducer } from '@/features/members/membersSlice';
import { guestsReducer } from '@/features/guests/guestsSlice';
import { persistedState, persistMiddleware } from './persist';

// НЕ передаём никаких дженериков сюда — пусть TS сам выведет форму состояния
const rootReducer = combineReducers({
    ui: uiReducer,
    videos: videosReducer,
    members: membersReducer,
    guests: guestsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const store = configureStore({
    reducer: rootReducer,
    preloadedState: (persistedState as Partial<RootState>) ?? undefined,
    middleware: (g) => g().concat(persistMiddleware),
    devTools: import.meta.env.DEV,
});

export type AppDispatch = typeof store.dispatch;
